import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import "./main.scss";

ReactDOM.render(<App/>, document.querySelector("#root"));